import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { NhaCungCapModel } from '../nha-cung-cap-model/nha-cung-cap.model';
const API_ROOT_URL = environment.ApiRoot + '/nhacungcap';
@Injectable()
export class NhaCungCapService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
			const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
			return this.http.get<any>(API_ROOT_URL + '/DM_NCC_List', { 
				headers: httpHeaders,
				params: httpParams
			});
	}
	getNhaCungCapById(itemId: any): Observable<any> {
		return this.http.get<any>(API_ROOT_URL + `/DM_NhaCC_Detail?Id_NCC=${itemId}`);
	}
	deleteNhaCungCap(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DM_NhaCC_Delete?Id_NCC=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	deleteNhaCungCaps(ids: any[] = []): Observable<any> {
		const url = API_ROOT_URL + '/DM_NhaCungCap_Multi_Delete';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<QueryResultsModel>(url, ids, { headers: httpHeaders} );
	}
	createNhaCungCap(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<NhaCungCapModel>(API_ROOT_URL+'/DM_NhaCungCap_Insert', item, { headers: httpHeaders });
	}
	createMultipleNhaCungCap(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<NhaCungCapModel>(API_ROOT_URL+'/NhaCungCap_InsertMuiltiple', item, { headers: httpHeaders });
	}
	updateNhaCungCap(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<NhaCungCapModel>(API_ROOT_URL+'/DM_NhaCungCap_Update', item, { headers: httpHeaders });
	}
	listId_LoaiNCC() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  API_ROOT_URL + '/DM_LoaiNhaCungCap_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	listId_Tinh() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_Tinh_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}

	 // Import hh
	downloadTemplate(): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<Blob>(API_ROOT_URL + '/DownLoadFileImportMau', {
		  headers: httpHeaders,
		  responseType: 'blob' as 'json'
		});
	}
	
	uploadFileImport(data): Observable<any> {
		const url = API_ROOT_URL + '/ImportFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	
	createMultiple(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/DM_Mutiple_Insert', item, { headers: httpHeaders });
	}
	
	getDanhSachMa(): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + '/DM_MaNCCLite', {
			headers: httpHeaders,
		});
	}
  
	exportFileExcel(queryParams: QueryParamsModel): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<Blob>(API_ROOT_URL + '/ExportFile', {
			headers: httpHeaders,
			params: httpParams,
			responseType: 'blob' as 'json'
		});
	}

	GetIDPhieuNhaCCNext(): Observable<any>{
		
		
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+'/NhaCC_GetIDPhieuNext', { headers: httpHeaders });
	}

	donwLoadFileMauNCC() {
		
		
		var request = new XMLHttpRequest();
		var link = environment.ApiRoot + '/nhacungcap' + `/DownloadFileImport_NhaCC`;
		request.open("GET", link);
	
		request.responseType = 'arraybuffer';
		request.onload = function (e) {
		
			
			var name = 'IMPORT_NHACC_MAU.xlsx';
			var file = new Blob([this.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			if (navigator.msSaveBlob) {
				return navigator.msSaveBlob(file);
			}
			
			var a = document.createElement("a");

			var url = window.URL.createObjectURL(file);
			a.setAttribute("href", url);
			a.setAttribute("download", name);

			a.click();
			
			window.URL.revokeObjectURL(url);
			

		};
		
		request.send();
		
		
	
	}

	importFileMauNCC(fileToUpload) : Observable<any>{
		
		let fileUpload= <File>fileToUpload[0];
		const formData: FormData = new FormData();
		formData.append('File', fileUpload, fileUpload.name);
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/ImportFileImport_NhaCC',formData ,{ headers: httpHeaders });
	}


	Xuatfile(queryParams:QueryParamsModel){
		
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		var request = new XMLHttpRequest();
		var link = API_ROOT_URL + `/ExportFileDMNCC?`+httpParams.toString();
		request.open('GET', link);
		
		request.responseType = 'arraybuffer';
		var _this=this;
		request.onload = function (e) {
			
			var name = "dmnhacungcap";
			var file = new Blob([this.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			if (navigator.msSaveBlob) {
				return navigator.msSaveBlob(file);
			}
			
			var a = document.createElement("a");

			var url = window.URL.createObjectURL(file);
			a.setAttribute("href", url);
			a.setAttribute("download", name);

			a.click();

			window.URL.revokeObjectURL(url);
			
		};
		request.send();
	}

}
